





















import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * Helpers
 */
import { sortByAsc } from "@/utils/sort-helpers";

/**
 * Components
 */
import TimeRangesEditor from "./components/TimeRangesEditor.vue";

/**
 * API
 */
import timeRangesAPI from "@/api/time-ranges";
import bookingsAPI, { ResourceBookableTimeRange, ResourceBooking, BookingCategory } from "@/api/bookings";
import servicesAPI, { ModePassage } from "@/api/services";

/**
 * Page d'éditeur de time ranges.
 */
@Component({
	components: { TimeRangesEditor },
	mixins: [mixinsAPI]
})
export default class TimeRangesEditorPage extends Vue {
	$refs!: {
		editor: TimeRangesEditor
	};

	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' })
	openInfo: any;
	@Action('openError', { namespace: 'snackbar' })
	openError: any;

	/** Attributs */
	isLoading = false;
	isActionLoading = false;
	// Les services possibles
	services: any[] = [];

	/** Méthodes */
	async created() {
		this.isLoading = true;
		await this.loadFilterDefinitionsData();
		this.isLoading = false;
	}

	async loadFilterDefinitionsData() {
		const services = await servicesAPI.getAll(ModePassage.RESOURCES);
		this.services = services.sort(sortByAsc((x) => x.label));
	}

	async fetchDayBookableTimeRanges(day: number, month: number, year: number): Promise<ResourceBookableTimeRange[]> {
		return await bookingsAPI.getAllowedDayBookableTimeRanges(day, month, year, false);
	}

	async fetchTimeRangesRules(serviceID: number): Promise<any[]> {
		return await timeRangesAPI.getAll(serviceID);
	}

	/**
	 * Callback lorsque l'on clique sur "Supprimer".
	 */
	async handleRemoveClick(timeRangeID: number) {
		const r = confirm(this.$t("global.confirm_removing__").toString());
		if (!r) {
			return;
		}

		this.isActionLoading = true;
		try {
			await timeRangesAPI.remove(timeRangeID);

			await this.$refs.editor.reloadData();

			this.openInfo(this.$t('snackbar.success'));
		}
		catch (err) {
			(this as any).handleAPIError(err);
		}
		this.isActionLoading = false;
	}
}
